/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API48378Req {
  
  /** 任务id */
  taskId?: number;
  /** 项目编号 */
  projectNo?: string;
  /** 项目计划编号 */
  planNo?: string;
  /** 任务标题,必填 */
  taskTitle?: string;
  /** 任务描述 */
  taskDesc?: string;
  /** 执行人用户id列表 ,String */
  taskExecutorIdList?: any[];
  /** 抄送人用户id列表 ,String */
  taskCcIdList?: any[];
  /** 任务完成标准(1:或签,2:会签，默认1)，详见com.ywwl.foundation.teamwork.client.enums.TaskCompleteTypeEnum */
  taskCompleteType?: number;
  /** 计划开始时间,yyyy-mm-ddhh:mm */
  startTime?: any;
  /** 计划完成时间,yyyy-mm-ddhh:mm */
  endTime?: any;
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  /** 能否处理已逾期的任务 */
  canExecOverdue?: boolean;
};



export type API48378Res = {};


// 48378 编辑任务

export interface IUsePostAPI48378Return {
  /** 编辑任务: 接口请求状态 */
  isAPI48378Loading: boolean;
  /** 编辑任务: 接口请求返回数据 */
  dataAPI48378: API48378Res;
  /**  编辑任务: 接口数据请求方法 */
  fetchAPI48378Data:  (inputs: API48378Req, config?: YWRequestConfig) => Promise<API48378Res>;
  /** 编辑任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48378 = ():IUsePostAPI48378Return => {
  let isMount = true;
  const [isAPI48378Loading, setIsAPI48378Loading] = useState(false);
  const [dataAPI48378, setDataAPI48378] = useState<API48378Res>({} as API48378Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/edit`;

  const fetchAPI48378Data = async (inputs: API48378Req, config?: YWRequestConfig): Promise<API48378Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48378Req>) || {}) as API48378Req;
    
  
    if ( isMount ) {
      setIsAPI48378Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48378Res>(`${basePath}/corp-admin/project/plan/task/edit`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48378(res || {} as API48378Res);
        setIsAPI48378Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48378Loading(false);
      }
      return false as unknown as API48378Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48378Loading,
    dataAPI48378,
    fetchAPI48378Data,
    requestUrl,
  }
}

